'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { ampli } from '@src/ampli-web';
import { Container } from '@src/components/Container/Container';
import { useTrackSelectCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';
interface SmallFooterProps {
  copyright: string;
  links: Array<{
    label: string;
    href: string;
  }>;
  badges: Array<{
    url: string;
    altText: string;
  }>;
}
export function SmallFooter(t0) {
  const $ = _c(21);
  const {
    copyright,
    links,
    badges
  } = t0;
  const trackSelectCta = useTrackSelectCta();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("border-t-2 border-bodi-gray-light bg-bodi-gray-pearl");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("grid grid-flow-row gap-5 px-6 py-9 text-center text-body-xs lg:grid-flow-col lg:px-40 lg:py-5 lg:text-left");
    t3 = cn("flex flex-col justify-center gap-5 lg:grow lg:justify-start lg:gap-1");
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== copyright) {
    t4 = <div>{copyright}</div>;
    $[3] = copyright;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== links || $[6] !== trackSelectCta) {
    let t6;
    if ($[8] !== links.length || $[9] !== trackSelectCta) {
      t6 = (link, index) => <LocalizedLink key={`${link.href}-${index}`} href={link.href} className="inline-block" target="_blank" onClick={() => {
        trackSelectCta({
          "cta url": link.href
        });
        ampli.flush();
      }}><div className={cn({
          "after:mx-1 after:content-['|']": index < links.length - 1
        })}>{link.label}</div></LocalizedLink>;
      $[8] = links.length;
      $[9] = trackSelectCta;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = links.map(t6);
    $[5] = links;
    $[6] = trackSelectCta;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div>{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== badges) {
    t8 = badges?.length && <div className={cn("flex flex-wrap justify-center gap-6 lg:flex-nowrap lg:justify-end")}>{badges.map(_temp)}</div>;
    $[16] = badges;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <footer className={t1}><Container className={t2}>{t7}{t8}</Container></footer>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp(badge, index_0) {
  return <Image key={`${badge.url}-${index_0}`} className="h-8 w-auto" src={badge.url} width={250} height={250} alt={badge.altText} />;
}